// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint[data-v-6ec63b79]{font-size:.75rem!important;line-height:1.2!important}.choice-text[data-v-6ec63b79]{font-size:.875rem;line-height:1.2;margin:20px 0 40px;flex-grow:1}.enter-manually-btn[data-v-6ec63b79]{margin-bottom:38px}.radio-group[data-v-6ec63b79] legend{width:100%;margin-bottom:10px;height:auto}", ""]);
// Exports
module.exports = exports;
